var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { useDependencyList } from '../useDependencyList/useDependencyList';
// type Function is used in order improve
// the type inference of callback rest params
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type -- Intentional: improves inference of callback rest params
export const useCallbackExtended = (callback, deps, comparator) => {
    _react_refresh_temp_1();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Intentional
    return useCallback(callback, useDependencyList(deps, comparator));
};
_react_refresh_temp_1(useCallbackExtended, "bZoUX0FL9ZHw3MP54S6jumGGf9U=", false, () => [useDependencyList]);
